import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST = 'FETCH_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST';
export const FETCH_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS = 'FETCH_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS';
export const FETCH_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE = 'FETCH_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE';

export const UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST = 'UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST';
export const UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS = 'UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS';
export const UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE = 'UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE';

const baseURLCollections = 'payment-collection-preferences';

export const fetchPaymentCollectionsPreferences = () => ({
  [CALL_API]: {
    endpoint: baseURLCollections,
    method: 'get',
    authenticated: true,
    types: [
      FETCH_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST,
      FETCH_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS,
      FETCH_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE,
    ],
  },
});

export const updatePaymentCollectionsPreferences = (updatedPreferences: IPaymentCollectionsPrefrencesRequest) => ({
  [CALL_API]: {
    endpoint: baseURLCollections,
    method: 'put',
    body: updatedPreferences,
    authenticated: true,
    types: [
      UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_REQUEST,
      UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_SUCCESS,
      UPDATE_PAYMENT_COLLECTIONS_PREFERENCES_FAILURE,
    ],
  },
});
